module.exports = "/assets/data/0319937fce6a39d150fbd27aa203e69a-BD15.data.json";